import _ from 'lodash';
import { availableSellingUnits } from './availableSellingUnits';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';

export function packingDetails(order: any, goodsObject: any, quantityInKg: number) {
  const sellingUnits: string[] = availableSellingUnits(_.get(order, 'product.packingMode', [])) || [];
  let packingDetails = '';
  sellingUnits.forEach((sellingUnit) => {
    packingDetails = `${packingDetails}${kgToSellingUnitQuantity(order, goodsObject, quantityInKg, sellingUnit)} ${sellingUnit}\n`;
  })
  return packingDetails;
}